import Card, { CardProps } from '@mui/material/Card';
import styled from 'styled-components';

const StyledCard = styled(Card)`
  &.dashboardPropertySelect {
    overflow-y: auto;
    border-radius: 0px;

    & > div:nth-child(1) {
      position: sticky;
      top: 0px;
      z-index: 1;
    }

    & > div:nth-child(2) {
      margin-top: ${props => props.theme.spacing(1)};
      height: ${props => props.theme.spacing(7)};
    }
  }

  .MuiCardHeader-root {
    padding: ${props => props.theme.spacing(1)}px ${props => props.theme.spacing(2)};
  }

  .MuiCardHeader-action {
    margin-top: 0;

    & .MuiButtonBase-root {
      padding: ${props => props.theme.spacing(0.5)};
    }
  }
`;

export default function StyledComponents(props: CardProps) {
  return <StyledCard {...props}></StyledCard>;
}
